import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store';
import { AUTH_CHECK_LOGIN, AUTH_LOGOUT } from '@/store/action-types';
import DocumentManage from "../pages/documents/DocumentManage";
import ProductDocuments from "../pages/documents/ProductDocuments";
import DocumentIndex from "../pages/documents/DocumentIndex";
import NotificationMessageIndex from "../pages/notifications/NotificationMessageIndex";
import DocumentFolderManage from "../pages/documents/DocumentFolderManage";
import Demonstrations from "../pages/Demonstrations";
import KnowledgebaseThreadIndex from "../pages/tools/faq/KnowledgebaseThreadIndex";
import KnowledgebaseThreadDetail from "../pages/tools/faq/KnowledgebaseThreadDetail";
import NotificationTabs from "../pages/notifications/NotificationTabs";
import DealerAgreement from "../pages/misc/DealerAgreement";
import ConfigDocumentManage from "../pages/documents/ConfigDocumentManage";
import ProductAccess from "../pages/customers/ProductAccess";
import CustomerDashboard from "../pages/customers/CustomerDashboard";
import ProductCatalog from "../pages/misc/ProductCatalog";

// Containers
const TheContainer = () => import('@/containers/TheContainer')

const ComingSoon = () => import('@/pages/ComingSoon')
const Dashboard = () => import('@/pages/Dashboard')
const Login = () => import('@/pages/Login')
const PasswordReset = () => import('@/pages/PasswordReset')
const BasePage = () => import('@/pages/BasePage')
const LeadManager = () => import('@/pages/tools/LeadManager')
const OrderIndex = () => import('@/pages/orders/OrderIndex')
const OrderCurrent = () => import('@/pages/orders/OrderCurrent')
const OrderClosed = () => import('@/pages/orders/OrderClosed')
const OrderDetail = () => import('@/pages/orders/OrderDetail')
const OrderBillOfLading = () => import('@/pages/orders/OrderBillOfLading')
const OrderLoadConfirmation = () => import('@/pages/orders/OrderLoadConfirmation')
const OrderAdd = () => import('@/pages/orders/OrderAdd')
const OrderEdit = () => import('@/pages/orders/OrderEdit')
const PriceListCurrent = () => import('@/pages/price-lists/PriceListCurrent.vue')
const EstimateIndex = () => import('@/pages/estimates/EstimateIndex')
const EstimateDetail = () => import('@/pages/estimates/EstimateDetail')
const EstimateApprove = () => import('@/pages/estimates/EstimateApprove')
const CustomerEstimateIndex = () => import('@/pages/estimates/CustomerEstimateIndex')
const CustomerEstimateAdd = () => import('@/pages/estimates/CustomerEstimateAdd')
const CustomerEstimateEdit = () => import('@/pages/estimates/CustomerEstimateEdit')
const CustomerContactInvite = () => import('@/pages/customers/contacts/CustomerContactInvite')
const CustomerContactSent = () => import('@/pages/customers/contacts/CustomerContactSent')
const EmployeeIndex = () => import('@/pages/employees/EmployeeIndex')
const AccountDashboard = () => import('@/pages/AccountDashboard')
const CustomerHowToVideos = () => import('@/pages/CustomerHowToVideos')
const SimpleCharge = () => import("../pages/tools/SimpleCharge")
const MasterAccount = () => import('@/pages/MasterAccount')

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
});

function configRoutes() {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      meta: { requiresAuth: false },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: { requiresAuth: true }
        },
        {
          path: 'tools',
          name: 'Tools',
          component: BasePage,
          meta: { requiresAuth: true },
          children: [
            {
              path: 'lead-manager',
              name: 'Lead Manager',
              component: LeadManager,
              meta: { requiresAuth: true },
            },
            {
              path: 'faq',
              name: 'FAQ',
              component: KnowledgebaseThreadIndex,
              meta: { requiresAuth: true },
            },
            {
              path: 'faq/:knowledgebase_thread_id',
              name: 'Knowledgebase / FAQ',
              component: KnowledgebaseThreadDetail,
              meta: { requiresAuth: true },
            },
            {
              path: 'report-card',
              name: 'Report Card',
              component: ComingSoon,
              meta: { requiresAuth: true },
            },
            {
              path: 'how-to',
              name: 'How To\'s',
              //component: ComingSoon,
              component: CustomerHowToVideos,
              meta: { requiresAuth: true, adminOnly: false }
            },
            {
              path: 'charge',
              name: 'Make Payment',
              component: SimpleCharge,
              meta: { requiresAuth: true, adminOnly: true }
            },
          ]
        },
        {
          path: 'orders',
          redirect: '/orders/current',
          name: 'Orders',
          component: BasePage,
          meta: { requiresAuth: true },
          children: [
            {
              path: 'list',
              name: 'Order List',
              component: OrderIndex,
              meta: { requiresAuth: true },
            },
            {
              path: 'add',
              name: 'New Order',
              component: OrderAdd,
              meta: { requiresAuth: true },
            },
            // {
            //   path: 'statuses',
            //   name: 'Statuses',
            //   component: ComingSoon,
            //   meta: { requiresAuth: true },
            // },
            {
              path: 'current',
              name: 'Current/Edit Orders',
              component: OrderCurrent,
              meta: { requiresAuth: true },
            },
            {
              path: 'closed',
              name: 'Closed Orders',
              component: OrderClosed,
              meta: { requiresAuth: true },
            },
            {
              path: 'offers',
              name: 'Offers',
              component: ComingSoon,
              meta: { requiresAuth: true },
            },
            {
              path: ':order_id',
              name: 'Order Details',
              component: OrderDetail,
              meta: { requiresAuth: true },
            },
            {
              path: ':order_id/edit',
              name: 'Edit Order Request',
              component: OrderEdit,
              meta: { requiresAuth: true },
              props: true,
            },
            {
              path: ':order_id/bill-of-lading',
              name: 'Bill Of Lading',
              component: OrderBillOfLading,
              meta: { requiresAuth: true },
            },
            {
              path: ':order_id/load-confirmation',
              name: 'Load Confirmation',
              component: OrderLoadConfirmation,
              meta: { requiresAuth: true },
            },
          ]
        },
        {
          path: 'estimates',
          redirect: '/estimates/list',
          name: 'Estimates',
          component: BasePage,
          meta: { requiresAuth: true },
          children: [
            {
              path: 'list',
              name: 'Estimate List',
              component: EstimateIndex,
              meta: { requiresAuth: true },
            },
            {
              path: 'approve',
              name: 'Approve Estimates',
              component: EstimateApprove,
              meta: { requiresAuth: true },
            },
            {
              path: 'add',
              name: 'New Estimate',
              component: CustomerEstimateAdd,
              meta: { requiresAuth: true },
            },
            {
              path: 'generated',
              name: 'My Estimates',
              component: CustomerEstimateIndex,
              meta: { requiresAuth: true },
            },
            {
              path: 'generated/:customer_estimate_id/edit',
              name: 'Edit Estimate',
              component: CustomerEstimateEdit,
              meta: { requiresAuth: true },
            },
            {
              path: ':estimate_id',
              name: 'Estimate Details',
              component: EstimateDetail,
              meta: { requiresAuth: true },
            },
          ]
        },
        {
          path: 'price-lists',
          redirect: '/price-lists/current',
          name: 'Price Lists',
          component: BasePage,
          meta: { requiresAuth: true },
          children: [
            {
              path: 'current',
              name: 'Price List',
              component: PriceListCurrent,
              meta: { requiresAuth: true },
            },
          ]
        },
        {
          path: 'documents',
          redirect: '/documents/marketing',
          name: 'Documents',
          component: BasePage,
          meta: { requiresAuth: true },
          children: [
            {
              path: 'configuration',
              name: 'Manage Configuration Documents',
              component: ConfigDocumentManage,
              meta: { requiresAuth: true, adminOnly: true },
            },
            {
              path: 'configuration/:editable',
              name: 'Manage Configuration Documents (Editable)',
              component: ConfigDocumentManage,
              meta: { requiresAuth: true, adminOnly: true },
              props: true,
            },
            {
              path: 'manage',
              name: 'Manage Documents',
              component: DocumentFolderManage,
              meta: { requiresAuth: true, adminOnly: true },
            },
            {
              path: 'manage/:folder_id',
              name: 'Manage Documents',
              component: DocumentManage,
              meta: { requiresAuth: true, adminOnly: true },
              props: true,
            },
            // {
            //   path: 'manage/:folder',
            //   name: 'Manage Documents',
            //   component: DocumentManage,
            //   meta: { requiresAuth: true, adminOnly: true },
            //   props: true
            // },
            {
              path: ':folder',
              name: 'View Documents',
              component: DocumentIndex,
              meta: { requiresAuth: true },
              props: true
            },
          ]
        },
        {
          path: 'customers',
          //redirect: '',
          name: 'Customers',
          component: BasePage,
          meta: { requiresAuth: true },
          children: [
            {
              path: '',
              name: 'Customer Dashboard',
              component: CustomerDashboard,
              meta: { requiresAuth: true, adminOnly: true },
            },
            {
              path: 'contacts/invite',
              name: 'Invite Contacts',
              component: CustomerContactInvite,
              meta: { requiresAuth: true, adminOnly: true },
            },
            {
              path: 'contacts/sent',
              name: 'Invited Contacts',
              component: CustomerContactSent,
              meta: { requiresAuth: true, adminOnly: true },
            },
            {
              path: 'product-access',
              name: 'Manage Product Access',
              component: ProductAccess,
              meta: { requiresAuth: true, adminOnly: true },
            },
          ]
        },
        {
          path: 'employees',
          redirect: '/employees/list',
          name: 'employees',
          component: BasePage,
          meta: { requiresAuth: true },
          children: [
            {
              path: 'list',
              name: 'Invite Employees',
              component: EmployeeIndex,
              meta: { requiresAuth: true },
            },
          ]
        },
        {
          path: 'products/documents',
          name: 'Product Documents',
          component: ProductDocuments,
          meta: { requiresAuth: true }
        },
        {
          path: 'settings',
          name: 'Settings',
          component: ComingSoon,
          meta: { requiresAuth: true },
        },
        {
          path: 'notifications',
          name: 'Notifications',
          component: NotificationTabs,
          meta: { requiresAuth: true, adminOnly: true }
        },
        {
          path: 'notifications/messages',
          name: 'Notification Messages',
          component: NotificationMessageIndex,
          meta: { requiresAuth: true, adminOnly: true }
        },
        {
          path: 'instructions',
          name: 'Instructions',
          component: Demonstrations,
          meta: { requiresAuth: true, adminOnly: true }
        },
        {
          path: 'dealer-agreement',
          name: 'Dealer Agreement',
          component: DealerAgreement,
          meta: { requiresAuth: true, adminOnly: false }
        },
        {
          path: 'product-catalog',
          name: 'Product Catalog',
          component: ProductCatalog,
          meta: { requiresAuth: true }
        },
        {
          path: 'account',
          name: 'My Account',
          component: AccountDashboard,
          meta: { requiresAuth: true, adminOnly: false }
        },
        {
          path: 'master-account',
          name: 'Master Account',
          component: MasterAccount,
          meta: { requiresAuth: true, adminOnly: true },
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/recover-password',
      name: 'Password Reset',
      component: PasswordReset,
      meta: { requiresAuth: false }
    },
  ]
}

router.beforeResolve(async (to, from, next) => {
  document.title = (to.name ? to.name + ' | ' : '') + 'My SuperForm';
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      let r = await store.dispatch(AUTH_CHECK_LOGIN);
      //next();
      if (to.matched.some(record => record.meta.adminOnly)) {
        if(!store.getters.isAdmin) {
          next('/');
        } else {
          next();
        }
      } else {
        next();
      }
    } catch (e) {
      await store.dispatch(AUTH_LOGOUT);
      if (to.path !== '/login') {
        next('/login');
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router;
